import React, { useContext, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {useNavigate} from 'react-router-dom';
import * as yup from 'yup';
import { Formik, ErrorMessage, Form, Field } from 'formik';
import { AuthContext } from '../../context/AuthContext';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="http://localhost:3000">
        EthioGlobal
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function ForgotPassword() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const { currentUser, login, logout,err } = useContext(AuthContext);
  
  const [values, setValues] = useState({
    username: "",
  })

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
        setLoading(true);
        await login(values);
        if(currentUser) {
          navigate('/');
        setNotification({
            show: true,
            type: 'success',
            message: 'Login successful!'
        });
        setIsRedirecting(true);
        const timer = setTimeout(() => {
        }, 3000);
        return () => clearTimeout(timer);
      }
      else {
        setNotification({
          show: true,
          type: 'error',
          message: 'Login failed. Please try again .'
        });
      }
      setLoading(false);
    } catch (error) {
        setNotification({
            show: true,
            type: 'error',
            message: error
        });
    } finally {
        setSubmitting(false);
        setIsRedirecting(false);
    }
  };

  const [notification, setNotification] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const validationSchema = yup.object({
    email: yup.string()
      .required('Email is required'),
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <Formik
            initialValues={{ email: '', password: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, handleChange, handleBlur, errors, touched }) => (
              <Form>
                <Box component="div" noValidate sx={{ mt: 1 }}>
                  <Field
                    as={TextField}
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    disabled={isSubmitting}
                  >
                    Send Request
                  </Button>
                  <Grid container spacing={2}>
                    <Grid item xs>
                    <Link href="/sign-in" variant="body2">
                        {"Already have an account? Sign In"}
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link href="/sign-up" variant="body2">
                        {"Don't have an account? Sign Up"}
                      </Link>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}